const AnimatedBackground = () => {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {/* Animated horizontal gradient flow */}
      <div 
        className="absolute inset-0 animate-gradient-flow opacity-15"
        style={{ 
          background: "linear-gradient(90deg, hsl(217 91% 60%) 0%, hsl(271 81% 56%) 50%, hsl(217 91% 60%) 100%)",
          backgroundSize: "200% 100%",
        }}
      />
      
      {/* Animated gradient blobs */}
      <div 
        className="absolute top-0 left-1/4 w-[600px] h-[600px] rounded-full blur-3xl animate-blob opacity-25"
        style={{ 
          background: "linear-gradient(135deg, hsl(217 91% 60%) 0%, hsl(271 81% 56%) 100%)",
        }}
      />
      <div 
        className="absolute bottom-0 right-1/4 w-[500px] h-[500px] rounded-full blur-3xl animate-blob animation-delay-2000 opacity-15"
        style={{ 
          background: "linear-gradient(135deg, hsl(271 81% 56%) 0%, hsl(217 91% 60%) 100%)",
        }}
      />
      <div 
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] rounded-full blur-3xl animate-blob animation-delay-4000 opacity-20"
        style={{ 
          background: "linear-gradient(135deg, hsl(217 91% 60%) 0%, hsl(200 80% 60%) 100%)",
        }}
      />
    </div>
  );
};

export default AnimatedBackground;
